import { compoundFilterReducer } from '../../CompoundFilter.reducer';
import { CompoundFilterStateActions } from '../../CompoundFilter.types';

import {
  UseCompoundFilterReducerProps,
  UseCompoundFilterReducerResult,
} from './useCompoundFilterReducer.types';

export const useCompoundFilterReducer = ({
  state,
  onChange,
}: UseCompoundFilterReducerProps): UseCompoundFilterReducerResult => {
  const dispatch = (action: CompoundFilterStateActions) => {
    return compoundFilterReducer(state, action, onChange);
  };

  return dispatch;
};
